import { render, staticRenderFns } from "./agreeDialog.vue?vue&type=template&id=ec73172e&scoped=true&"
import script from "./agreeDialog.vue?vue&type=script&lang=js&"
export * from "./agreeDialog.vue?vue&type=script&lang=js&"
import style0 from "./agreeDialog.vue?vue&type=style&index=0&id=ec73172e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec73172e",
  null
  
)

export default component.exports